<template>
  <div>
    <b-card>
      <b-card-header class="pb-1">
        <b-card-title>{{ isEdit ? $t('serviceActions.edit') : $t('serviceActions.create') }}</b-card-title>
      </b-card-header>

      <b-card-body>
        <b-form @submit.prevent="handleSubmit">
          <b-row>
            <!-- Service -->
            <b-col
              cols="12"
              md="6"
            >
              <!-- :disabled="isEdit" -->
              <b-form-group
                :label="$t('serviceActions.fields.service') + ' *'"
                label-for="service"
              >
                <v-select
                  v-model="form.service_id"
                  :options="serviceOptions"
                  :reduce="option => option.value"
                  label="label"
                  :placeholder="$t('serviceActions.placeholders.service')"
                  :state="errors.service_id ? false : null"

                  @search="onServiceSearch"
                />
                <b-form-invalid-feedback
                  v-if="errors.service_id"
                  :state="false"
                >
                  {{ errors.service_id[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Parent Action -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('serviceActions.fields.parent_action')"
                label-for="parent-action"
              >
                <v-select
                  v-model="form.parent_action_id"
                  :options="parentActionOptions"
                  :reduce="option => option.id"
                  label="name"
                  :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                  :placeholder="$t('serviceActions.placeholders.parent_action')"
                  :state="errors.parent_action_id ? false : null"
                />
                <b-form-invalid-feedback
                  v-if="errors.parent_action_id"
                  :state="false"
                >
                  {{ errors.parent_action_id[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Name -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('serviceActions.fields.name') + ' *'"
                label-for="name"
              >
                <b-form-input
                  id="name"
                  v-model="form.name"
                  :placeholder="$t('serviceActions.placeholders.name')"
                  :state="errors.name ? false : null"
                />
                <b-form-invalid-feedback v-if="errors.name">
                  {{ errors.name[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Default Responsibility Type -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('serviceActions.fields.responsibility_type')"
                label-for="responsibility-type"
              >
                <v-select
                  v-model="form.default_responsibility_type"
                  :options="responsibilityOptions"
                  :reduce="option => option.value"
                  label="label"
                  :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                  :placeholder="$t('serviceActions.placeholders.responsibility_type')"
                  :state="errors.default_responsibility_type ? false : null"
                />
                <b-form-invalid-feedback
                  v-if="errors.default_responsibility_type"
                  :state="false"
                >
                  {{ errors.default_responsibility_type[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!--  responsible employee -->
            <b-col
              cols="12"
              md="6"
            >
              <b-form-group
                :label="$t('serviceActions.fields.responsible_employee')"
                label-for="responsible_employee"
              >
                <v-select
                  v-model="form.responsible_employee_id"
                  :options="lookups"
                  :reduce="val => val.id"
                  :get-option-label="option => option.full_name"
                  label="label"
                  :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
                  :placeholder="$t('serviceActions.placeholders.responsible_employee')"
                  :state="errors.responsible_employee_id ? false : null"
                  @search="onEmployeeSearch"
                />
                <b-form-invalid-feedback
                  v-if="errors.responsible_employee_id"
                  :state="false"
                >
                  {{ errors.responsible_employee_id[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Description -->
            <b-col cols="12">
              <b-form-group
                :label="$t('serviceActions.fields.description')"
                label-for="description"
              >
                <b-form-textarea
                  id="description"
                  v-model="form.description"
                  :placeholder="$t('serviceActions.placeholders.description')"
                  rows="3"
                  :state="errors.description ? false : null"
                />
                <b-form-invalid-feedback v-if="errors.description">
                  {{ errors.description[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Estimated Hours -->
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('serviceActions.fields.estimated_hours')"
                label-for="estimated-hours"
              >
                <b-form-input
                  id="estimated-hours"
                  v-model.number="form.estimated_hours"
                  type="number"
                  step="0.1"
                  min="0.1"
                  :placeholder="$t('serviceActions.placeholders.estimated_hours')"
                  :state="errors.estimated_hours ? false : null"
                />
                <b-form-invalid-feedback v-if="errors.estimated_hours">
                  {{ errors.estimated_hours[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Estimated Cost -->
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('serviceActions.fields.estimated_cost')"
                label-for="estimated-cost"
              >
                <b-input-group prepend="$">
                  <b-form-input
                    id="estimated-cost"
                    v-model.number="form.estimated_cost"
                    type="number"
                    step="0.01"
                    min="0"
                    :placeholder="$t('serviceActions.placeholders.estimated_cost')"
                    :state="errors.estimated_cost ? false : null"
                  />
                </b-input-group>
                <b-form-invalid-feedback v-if="errors.estimated_cost">
                  {{ errors.estimated_cost[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Order -->
            <b-col
              cols="12"
              md="4"
            >
              <b-form-group
                :label="$t('serviceActions.fields.order')"
                label-for="order"
              >
                <b-form-input
                  id="order"
                  v-model.number="form.order"
                  type="number"
                  min="0"
                  :placeholder="$t('serviceActions.placeholders.order')"
                  :state="errors.order ? false : null"
                />
                <b-form-invalid-feedback v-if="errors.order">
                  {{ errors.order[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Issuing Authority -->
            <b-col cols="12">
              <b-form-group
                :label="$t('serviceActions.fields.issuing_authority')"
                label-for="issuing-authority"
              >
                <b-form-input
                  id="issuing-authority"
                  v-model="form.issuing_authority"
                  :placeholder="$t('serviceActions.placeholders.issuing_authority')"
                  :state="errors.issuing_authority ? false : null"
                />
                <b-form-invalid-feedback v-if="errors.issuing_authority">
                  {{ errors.issuing_authority[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <!-- Is Active -->
            <b-col cols="12">
              <b-form-group>
                <b-form-checkbox
                  v-model="form.is_active"
                  switch
                >
                  {{ $t('common.active') }}
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <!-- Buttons -->
            <b-col cols="12">
              <b-button
                type="submit"
                variant="primary"
                :disabled="loading"
              >
                <b-spinner
                  v-if="loading"
                  small
                  class="mr-50"
                />
                <feather-icon
                  v-else
                  icon="SaveIcon"
                  class="mr-50"
                />
                <span class="align-middle">{{ isEdit ? $t('common.update') : $t('common.create') }}</span>
              </b-button>
              <b-button
                variant="outline-secondary"
                class="ml-1"
                :to="{ name: 'service-actions-list' }"
              >
                <feather-icon
                  icon="XIcon"
                  class="mr-50"
                />
                <span class="align-middle">{{ $t('common.cancel') }}</span>
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </b-card-body>
    </b-card>

    <!-- Activity Logs Section (Only for Edit Mode) -->
    <b-card
      v-if="isEdit && hasPermission('view activity_logs')"
      class="mt-2"
    >
      <b-card-header class="pb-1">
        <b-card-title>سجل النشاطات</b-card-title>
      </b-card-header>
      <b-card-body>
        <ActivityLogs
          :model-type="'service-action'"
          :model-id="Number($route.params.id)"
          :show-filters="true"
          :per-page="15"
        />
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BForm,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BFormCheckbox,
  BFormInvalidFeedback,
  BButton,
  BSpinner,
  BInputGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { mapActions, mapGetters } from 'vuex'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getResponsibilityTypes } from '@/api/services/serviceActions'
import ActivityLogs from '@/components/ActivityLogs.vue'

export default {
  name: 'ServiceActionsForm',
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BFormCheckbox,
    BFormInvalidFeedback,
    BButton,
    BSpinner,
    BInputGroup,
    vSelect,
    ActivityLogs,
  },
  data() {
    return {
      form: {
        service_id: null,
        parent_action_id: null,
        name: '',
        description: '',
        default_responsibility_type: 1,
        responsible_employee_id: null,
        estimated_hours: null,
        estimated_cost: null,
        issuing_authority: '',
        order: 0,
        is_active: true,
      },
      errors: {},
      loading: false,
      serviceOptions: [],
      parentActionOptions: [],
      responsibilityOptions: [],
    }
  },
  computed: {
    ...mapGetters({
      lookups: 'employees/lookups',
    }),
    isEdit() {
      return !!this.$route.params.id
    },
  },
  watch: {
    'form.service_id': {
      handler(newVal) {
        if (newVal) {
          this.loadActionsForService(newVal)
        }
      },
    },
  },
  created() {
    this.loadServices()
    this.loadResponsibilityTypes()
    if (this.isEdit) {
      this.loadServiceAction()
    } else if (this.$route.query.service_id) {
      this.form.service_id = parseInt(this.$route.query.service_id, 10)
    }
  },
  methods: {
    hasPermission(permission) {
      const userPermissions = this.$store.getters['users/user_permissions']
      if (Array.isArray(userPermissions)) {
        return userPermissions.includes(permission)
      }
      return Object.values(userPermissions || {}).includes(permission)
    },
    ...mapActions('serviceActions', [
      'fetchServiceAction',
      'createServiceAction',
      'updateServiceAction',
      'getActionsForService',
    ]),
    ...mapActions('services', ['fetchServices']),
    async loadServices(keyword = '') {
      try {
        const response = await this.fetchServices({ all: true, keyword })
        this.serviceOptions = response.data.map(s => ({
          label: `${s.name} (${s.service_code})`,
          value: s.id,
        }))
      } catch (error) {
        console.error('Failed to load services:', error)
      }
    },
    async loadResponsibilityTypes() {
      try {
        const response = await getResponsibilityTypes()
        if (response.data && Array.isArray(response.data)) {
          this.responsibilityOptions = response.data.map(type => ({
            label: type.label || type.name,
            value: type.value || type.id,
          }))
        }
      } catch (error) {
        console.error('Failed to load responsibility types:', error)
        // Fallback to empty array if API fails
        this.responsibilityOptions = []
      }
    },
    async loadActionsForService(serviceId) {
      if (!serviceId) {
        this.parentActionOptions = [{ label: this.$t('serviceActions.messages.none_root_action'), value: null }]
        return
      }
      try {
        const response = await this.getActionsForService(serviceId)
        this.parentActionOptions = response?.data
        console.log('parentActionOptions', this.parentActionOptions)
        // console.log('data', data)
        // const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : []
        // console.log('list', list)
        // this.parentActionOptions = [
        //   { label: this.$t('serviceActions.messages.none_root_action'), value: null },
        //   ...list.map(a => ({
        //     label: a.name,
        //     value: a.id,
        //   })),
        // ]
      } catch (error) {
        console.error('Failed to load actions:', error)
        this.parentActionOptions = [{ label: this.$t('serviceActions.messages.none_root_action'), value: null }]
      }
    },
    async loadServiceAction() {
      try {
        this.loading = true
        const response = await this.fetchServiceAction(this.$route.params.id)
        this.form = {
          service_id: response.data.service_id,
          parent_action_id: response.data.parent_action_id,
          name: response.data.name,
          description: response.data.description,
          default_responsibility_type: response.data.default_responsibility_type,
          responsible_employee_id: response.data.responsible_employee_id,
          estimated_hours: response.data.estimated_hours,
          estimated_cost: response.data.estimated_cost,
          issuing_authority: response.data.issuing_authority,
          order: response.data.order,
          is_active: response.data.is_active,
        }
        // Load actions for the service
        if (this.form.service_id) {
          await this.loadActionsForService(this.form.service_id)
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('common.error'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.response?.data?.message || this.$t('serviceActions.messages.load_error'),
          },
        })
        this.$router.push({ name: 'service-actions-list' })
      } finally {
        this.loading = false
      }
    },
    async handleSubmit() {
      try {
        this.loading = true
        this.errors = {}

        if (this.isEdit) {
          await this.updateServiceAction({
            id: this.$route.params.id,
            data: this.form,
          })
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.success'),
              icon: 'CheckIcon',
              variant: 'success',
              text: this.$t('serviceActions.messages.update_success'),
            },
          })
        } else {
          await this.createServiceAction(this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('common.success'),
              icon: 'CheckIcon',
              variant: 'success',
              text: this.$t('serviceActions.messages.create_success'),
            },
          })
        }

        this.$router.push({ name: 'service-actions-list' })
      } catch (error) {
        if (error.response?.status === 422) {
          this.errors = error.response.data.errors || {}
        }
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t('common.error'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error.response?.data?.message || (this.isEdit ? this.$t('serviceActions.messages.update_error') : this.$t('serviceActions.messages.create_error')),
          },
        })
      } finally {
        this.loading = false
      }
    },
    onServiceSearch(search, loading) {
      loading(true)
      this.loadServices(search).then(() => loading(false))
    },
    // test employee search
    onEmployeeSearch(search, loading) {
      loading(true)
      this.$store.dispatch('employees/lookups', { keyword: search }).then(res => {
      })
    },
  },
  mounted() {
    this.$store.dispatch('employees/lookups').then(res => {
    })
  },
}
</script>
